/** Whole days between an ISO timestamp and `now`, never negative. */
export function daysSince(iso: string, now: Date): number {
  return Math.max(
    0,
    Math.floor((now.getTime() - new Date(iso).getTime()) / 86_400_000)
  )
}
